export const name = 'paste';

export const Paste = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    color="#161619"
    fill="none"
  >
    <path
      d="M16 3.99994H20C20 3.99994 20 4 20 6V21.9999C15.3333 21.9999 8.66667 21.9999 4 21.9999V4.00002C4 3.98079 7.47953 3.99994 8 3.99994"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 16H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15 2H9C8 2 8 2 8 3V5C8 6 8 6 9 6H15C16 6 16 6 16 5V3C16 2 16 2 15 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
